/* CasterHQ CAD Builder v1 (DRAFT 2026-10-10). Data: chq-cad-builder-v1.json. No dependencies. */
(function () {
  'use strict';
  var root = document.getElementById('cadb');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var track = function (name, params) {
    params = params || {};
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (e) {}
  };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- labels ---------- */
  var MOUNT = { P: ['plate', 'Plate'], T: ['threaded', 'Threaded stem'], G: ['grip', 'Grip ring stem'], E: ['expanding', 'Expanding stem'] };
  var MAT = { poly: 'Polyurethane', nylon: 'Nylon', rubber: 'Rubber', tpr: 'Elastomer', phenolic: 'Phenolic', polyolefin: 'Polyolefin', iron: 'Cast or ductile iron', other: 'Other' };
  var RIG = { S: ['swivel', 'Swivel'], R: ['rigid', 'Rigid'] };
  var BRK = { N: ['none', 'No brake'], W: ['wheel', 'Wheel brake'], T: ['total', 'Total lock'] };
  var CAPS = [100, 250, 500, 750, 1000, 1500, 2000, 3000];
  var OAH = [['u3', 'Under 3 in', 0, 3], ['3-5', '3 to 5 in', 3, 5], ['5-7', '5 to 7 in', 5, 7], ['7-9', '7 to 9 in', 7, 9], ['9up', '9 in and up', 9, 99]];
  function fracLabel(x) {
    if (x == null) return '';
    var w = Math.floor(x + 1e-6), f = x - w, best = '', err = 1;
    [[1, 2], [1, 4], [3, 4], [1, 8], [3, 8], [5, 8], [7, 8], [1, 16], [3, 16], [5, 16], [7, 16], [9, 16], [11, 16], [13, 16], [15, 16], [1, 3], [2, 3]].forEach(function (p) {
      var e = Math.abs(f - p[0] / p[1]); if (e < err) { err = e; best = p[0] + '/' + p[1]; }
    });
    if (f < 0.02) return w + ' in';
    if (err < 0.02) return (w ? w + '-' : '') + best + ' in';
    return (+x.toFixed(2)) + ' in';
  }
  var imgw = function (u, w) { return u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : ''; };
  var numKey = function (x) { return String(+(+x).toFixed(4)); };

  /* ---------- facets ---------- */
  var FACETS = [
    { id: 'mount', label: 'Mount', get: function (p) { return MOUNT[p.m] ? MOUNT[p.m][0] : ''; }, opts: function () { return Object.keys(MOUNT).map(function (k) { return [MOUNT[k][0], MOUNT[k][1]]; }); } },
    { id: 'dia', label: 'Wheel diameter', get: function (p) { return p.d ? numKey(p.d) : ''; }, num: 'd' },
    { id: 'w', label: 'Wheel width', get: function (p) { return p.w ? numKey(p.w) : ''; }, num: 'w' },
    { id: 'mat', label: 'Wheel material', get: function (p) { return p.mt; }, opts: function () { return Object.keys(MAT).map(function (k) { return [k, MAT[k]]; }); } },
    { id: 'cap', label: 'Capacity (at least)', test: function (p, v) { return p.c >= +v; }, opts: function () { return CAPS.map(function (c) { return [String(c), c.toLocaleString('en-US') + '+ lb']; }); } },
    { id: 'rig', label: 'Swivel or rigid', get: function (p) { return RIG[p.r][0]; }, opts: function () { return [['swivel', 'Swivel'], ['rigid', 'Rigid']]; } },
    { id: 'brake', label: 'Brake', get: function (p) { return BRK[p.b][0]; }, opts: function () { return [['none', 'No brake'], ['wheel', 'Wheel brake'], ['total', 'Total lock']]; } },
    { id: 'oah', label: 'Overall height', test: function (p, v) { var r = OAH.filter(function (o) { return o[0] === v; })[0]; return !!r && p.o != null && p.o >= r[2] && p.o < r[3]; }, opts: function () { return OAH.map(function (o) { return [o[0], o[1]]; }); } },
    { id: 'size', label: 'Plate size', get: function (p) { return p.ms ? p.ms.replace(/"/g, '').replace(/\s+/g, '') : ''; }, dyn: true }
  ];
  var FBY = {}; FACETS.forEach(function (f) { FBY[f.id] = f; });
  var WEIGHT = { mount: 6, dia: 5, w: 3, mat: 4, cap: 5, rig: 4, brake: 3, oah: 2, size: 4 };

  var bootHold = false, P = [], state = {}, sel = null, current = [], variantCache = {}, mvReady = false, mvLoading = false, mvEl = null, firstFilter = true;

  function matches(p, fid, v) {
    var f = FBY[fid];
    if (f.test) return f.test(p, v);
    return f.get(p) === v;
  }
  function filtered(except) {
    return P.filter(function (p) {
      for (var k in state) { if (k !== except && state[k] != null && !matches(p, k, state[k])) return false; }
      return true;
    });
  }

  /* ---------- URL state ---------- */
  function readURL() {
    var q = new URLSearchParams(location.search);
    FACETS.forEach(function (f) { var v = q.get(f.id); if (v) state[f.id] = v; });
    if (q.get('plate') && !state.size) state.size = q.get('plate');
    if (q.get('stem') && !state.size) state.size = q.get('stem');
    return q.get('sku');
  }
  function writeURL() {
    var q = new URLSearchParams(location.search);
    FACETS.forEach(function (f) { q.delete(f.id); if (state[f.id] != null) q.set(f.id, state[f.id]); });
    q.delete('plate'); q.delete('stem'); q.delete('sku');
    if (sel && sel._pinned) q.set('sku', sel.s);
    var s = q.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s.replace(/%2F/g, '/') : '') + location.hash);
  }

  /* ---------- pickers ---------- */
  function optsFor(f) {
    if (f.opts) return f.opts();
    var seen = {};
    var pool = f.dyn ? P.filter(function (p) { return !state.mount || matches(p, 'mount', state.mount); }) : P;
    pool.forEach(function (p) { var v = f.get(p); if (v) seen[v] = f.dyn ? p.ms : (f.num === 'd' ? (p.dl && p.dl.indexOf('.') < 0 ? p.dl : fracLabel(p.d)) : (p.wl && p.wl.indexOf('.') < 0 ? p.wl : fracLabel(p.w))); });
    var keys = Object.keys(seen);
    if (f.num) keys.sort(function (a, b) { return +a - +b; });
    else keys.sort(function (a, b) { return (parseFloat(a) || 0) - (parseFloat(b) || 0) || a.localeCompare(b); });
    return keys.map(function (k) { var l = seen[k]; if (f.num) l = l.replace(/"$/, ' in').replace(/"/g, ' in'); return [k, l.replace(/"/g, ' in')]; });
  }
  function renderPickers() {
    var host = $('[data-cadb-groups]');
    var html = '';
    FACETS.forEach(function (f) {
      if (f.id === 'size') {
        if (!state.mount) return;
        f.label = state.mount === 'plate' ? 'Plate size' : 'Stem size';
      }
      var base = filtered(f.id);
      var opts = optsFor(f);
      if (!opts.length) return;
      var counts = opts.map(function (o) { var n = 0; for (var i = 0; i < base.length; i++) if (matches(base[i], f.id, o[0])) n++; return n; });
      if (f.id !== 'mount' && f.id !== 'rig' && f.id !== 'brake' && f.id !== 'cap' && f.id !== 'oah') {
        /* hide options that exist nowhere in the catalog for this facet (keeps rows short); keep zero-in-context ones greyed */
        opts = opts.filter(function (o, i) { return P.some(function (p) { return matches(p, f.id, o[0]); }); });
      }
      var gid = 'cadb-g-' + f.id;
      html += '<div class="cadb-group" role="group" aria-labelledby="' + gid + '"><h3 class="cadb-group-h" id="' + gid + '">' + esc(f.label) +
        (state[f.id] != null ? ' <button type="button" data-clear="' + f.id + '">Clear</button>' : ' <small>Any</small>') + '</h3><div class="cadb-chips">';
      opts.forEach(function (o) {
        var n = 0; for (var i = 0; i < base.length; i++) if (matches(base[i], f.id, o[0])) n++;
        var on = state[f.id] === o[0];
        html += '<button type="button" class="cadb-chip' + (n ? '' : ' is-zero') + '" data-f="' + f.id + '" data-v="' + esc(o[0]) + '" aria-pressed="' + on + '" aria-label="' + esc(o[1]) + ', ' + (n ? n + ' match' + (n === 1 ? '' : 'es') : 'no exact match, shows the closest') + '">' + esc(o[1]) + ' <span class="n" aria-hidden="true">' + n + '</span></button>';
      });
      html += '</div></div>';
    });
    host.innerHTML = html;
    host.setAttribute('aria-busy', 'false');
    host.querySelectorAll('.cadb-chips').forEach(function (row) { var on = row.querySelector('[aria-pressed=true]'); if (on && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, on.offsetLeft - row.offsetLeft - 40); });
    $('[data-cadb-reset]').hidden = !Object.keys(state).length;
  }

  /* ---------- matching ---------- */
  function score(p) {
    var s = 0, miss = [];
    for (var k in state) {
      if (state[k] == null) continue;
      if (matches(p, k, state[k])) { s += WEIGHT[k] * 10; continue; }
      miss.push(k);
      var v = state[k], f = FBY[k];
      if (k === 'dia' && p.d) s += Math.max(0, WEIGHT[k] * 10 - Math.abs(p.d - v) * 6);
      else if (k === 'w' && p.w) s += Math.max(0, WEIGHT[k] * 10 - Math.abs(p.w - v) * 8);
      else if (k === 'cap') s += p.c >= +v * 0.8 ? WEIGHT[k] * 5 : 0;
      else if (k === 'oah' && p.o != null) { var r = OAH.filter(function (o) { return o[0] === v; })[0]; if (r) { var mid = (r[2] + Math.min(r[3], 12)) / 2; s += Math.max(0, WEIGHT[k] * 6 - Math.abs(p.o - mid) * 3); } }
    }
    return { s: s, miss: miss };
  }
  function diffText(p, miss) {
    return miss.map(function (k) {
      var v = state[k];
      switch (k) {
        case 'mount': return MOUNT[p.m][1] + ' instead of ' + labelFor('mount', v).toLowerCase();
        case 'dia': return (p.dl || fracLabel(p.d)).replace(/"/g, ' in') + ' wheel instead of ' + fracLabel(+v);
        case 'w': return (p.wl || fracLabel(p.w)).replace(/"/g, ' in') + ' wide instead of ' + fracLabel(+v);
        case 'mat': return (MAT[p.mt] || p.ml) + ' instead of ' + labelFor('mat', v).toLowerCase();
        case 'cap': return p.c.toLocaleString('en-US') + ' lb instead of ' + (+v).toLocaleString('en-US') + '+ lb';
        case 'rig': return RIG[p.r][1] + ' instead of ' + v;
        case 'brake': return BRK[p.b][1] + ' instead of ' + labelFor('brake', v).toLowerCase();
        case 'oah': return (p.ol || '?').replace(/"/g, ' in') + ' tall instead of ' + labelFor('oah', v).toLowerCase();
        case 'size': return (p.ms || 'a different size').replace(/"/g, ' in') + ' instead of ' + labelFor('size', v);
      }
      return '';
    }).filter(Boolean);
  }
  function labelFor(fid, v) {
    var f = FBY[fid]; var o = optsFor(f).filter(function (x) { return x[0] === v; })[0];
    return o ? o[1] : v;
  }
  function compute() {
    var exact = filtered();
    var res;
    if (exact.length) {
      exact.sort(function (a, b) { return a.pr - b.pr || a.c - b.c; });
      res = { exact: true, list: exact };
    } else {
      var sc = P.map(function (p) { var r = score(p); return { p: p, s: r.s, miss: r.miss }; });
      sc.sort(function (a, b) { return b.s - a.s || a.miss.length - b.miss.length || a.p.pr - b.p.pr; });
      res = { exact: false, list: sc.slice(0, 40).map(function (x) { x.p._miss = x.miss; return x.p; }) };
      track('cadb_no_match', { filters: JSON.stringify(state) });
    }
    return res;
  }

  /* ---------- match card ---------- */
  function specRows(p) {
    var rows = [];
    rows.push(['Mount', MOUNT[p.m][1] + (p.ms ? ', ' + p.ms : '')]);
    if (p.bh) rows.push(['Bolt pattern', p.bh]);
    rows.push(['Wheel', (p.dl || fracLabel(p.d)) + (p.wl ? ' x ' + p.wl : '') + (p.ml ? ' ' + p.ml : '')]);
    rows.push(['Capacity', p.c ? p.c.toLocaleString('en-US') + ' lb' : 'See product page']);
    rows.push(['Type', RIG[p.r][1] + ', ' + BRK[p.b][1].toLowerCase()]);
    if (p.ol) rows.push(['Overall height', p.ol]);
    if (p.sr && p.r === 'S') rows.push(['Swivel radius', p.sr]);
    return rows;
  }
  function dlLinks(p) {
    var a = [];
    if (p.st) a.push({ k: 'step', href: p.st, t: 'STEP 3D model', s: p.ss, n: p.st.split('/').pop().split('?')[0] });
    if (p.z) a.push({ k: 'zip', href: p.z, t: 'Set STEP files (.zip)', s: '', n: '' });
    if (p.os) a.push({ k: 'step-oem', href: p.os, t: 'Manufacturer STEP', s: '', n: p.os.split('/').pop().split('?')[0] });
    p.dr.forEach(function (d, i) { a.push({ k: 'drawing', href: d, t: i ? 'Drawing, sheet ' + (i + 1) : 'Drawing (PNG)', s: '', n: '' }); });
    if (p.g) a.push({ k: 'glb', href: p.g, t: '3D view file (GLB)', s: '', n: '' });
    return a;
  }
  function chqLic(ls) { return ls.some(function (l) { return (l.k === 'step' && /^CasterHQ-/i.test(l.n)) || l.k === 'zip'; }); }
  function purl(p) { return p.h ? '/products/' + p.h : '/variants/' + p.vid; }
  function cardMedia(p, tab) {
    if (tab === '3d' && p.g) return '<div class="cadb-cmv" data-cadb-cmv></div>';
    if (tab === 'drawing' && p.dr[0]) return '<button type="button" class="cadb-cimg cadb-cimg--draw" data-zoom="' + esc(p.dr[0]) + '" aria-label="Zoom the ' + esc(p.s) + ' drawing"><img src="' + esc(imgw(p.dr[0], 900)) + '" alt="' + esc(p.s) + ' dimensional drawing"><small>Tap to zoom</small></button>';
    return '<a class="cadb-cimg" href="' + esc(purl(p)) + '" data-cadb-view><img src="' + esc(imgw(p.img, 900)) + '" srcset="' + esc(imgw(p.img, 500)) + ' 500w, ' + esc(imgw(p.img, 900)) + ' 900w" sizes="(min-width: 990px) 400px, 92vw" alt="' + esc(genTitle(p)) + '"></a>';
  }
  function renderCard(res) {
    var card = $('[data-cadb-card]');
    var p = sel;
    if (!p) { card.innerHTML = ''; return; }
    var close = !res.exact && !p._pinned;
    var diffs = close ? diffText(p, p._miss || []) : [];
    var links = dlLinks(p);
    var step = links.filter(function (l) { return l.k === 'step'; })[0];
    var others = links.filter(function (l) { return l.k !== 'step'; });
    var price = p.px > p.pr ? 'From ' + money(p.pr) : money(p.pr);
    var tabs = [['photo', 'Photo']]; if (p.g) tabs.push(['3d', '3D']); if (p.dr[0]) tabs.push(['drawing', 'Drawing']);
    card.innerHTML =
      '<div class="cadb-card-top">' +
        (p._pinned ? '<span class="cadb-flag">Part # match</span>' : close ? '<span class="cadb-flag cadb-flag--close">Closest match</span>' : '<span class="cadb-flag">Exact match</span>') +
        (p.g ? '<span class="cadb-flag cadb-flag--3d">3D + STEP</span>' : '<span class="cadb-flag cadb-flag--3d">STEP download</span>') +
        (diffs.length ? '<p class="cadb-diff">' + esc(diffs.join('. ')) + '. Everything else matches.</p>' : '') +
      '</div>' +
      '<div class="cadb-cmedia" data-cadb-cmedia>' + cardMedia(p, 'photo') + '</div>' +
      (tabs.length > 1 ? '<div class="cadb-tabs" role="tablist" aria-label="Product views">' + tabs.map(function (t, i) { return '<button type="button" role="tab" data-tab="' + t[0] + '" aria-selected="' + (i === 0) + '">' + t[1] + '</button>'; }).join('') + '</div>' : '') +
      '<div class="cadb-card-body">' +
        '<h3 class="cadb-title"><a href="' + esc(purl(p)) + '" data-cadb-view>' + esc(genTitle(p)) + '</a></h3>' +
        '<div class="cadb-pn"><span>Part # <b>' + esc(p.s) + '</b></span><span class="cadb-price" data-cadb-price>' + price + '</span></div>' +
        '<dl class="cadb-spec" aria-label="Key specs for ' + esc(p.s) + '">' +
          specRows(p).map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd' + (r[0] === 'Type' ? ' data-cadb-type' : '') + '>' + esc(r[1]) + '</dd></div>'; }).join('') +
        '</dl>' +
      '</div>' +
      '<div class="cadb-buy">' +
        '<div class="cadb-opts" data-cadb-opts></div>' +
        '<a class="cadb-btn cadb-btn--view" href="' + esc(purl(p)) + '" data-cadb-view>View product</a>' +
        '<div class="cadb-qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">&minus;</button><input type="number" min="1" value="4" inputmode="numeric" aria-label="Quantity" data-cadb-qty><button type="button" data-qty="1" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="cadb-btn cadb-btn--cart" data-cadb-cart>Add to cart</button>' +
      '</div>' +
      '<div class="cadb-dls">' +
        (step ? '<a class="cadb-btn cadb-btn--step" href="' + esc(step.href) + '" download="' + esc(step.n) + '" rel="nofollow" data-dl="step"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.5l8 4.5v9l-8 4.5-8-4.5v-9z"/><path d="M4 7l8 4.5L20 7"/><path d="M12 11.5V20.5"/></svg>Download STEP <small>' + esc(step.s) + '</small></a>' : '') +
        (chqLic(links) ? '<p class="cadb-lic">Free for design use. Redistribution or resale prohibited.</p>' : '') +
        others.map(function (l) { return '<a class="cadb-btn cadb-btn--ghost" href="' + esc(l.href) + '" ' + (l.k === 'drawing' ? 'target="_blank" rel="noopener nofollow"' : 'download rel="nofollow"') + ' data-dl="' + l.k + '">' + esc(l.t) + '</a>'; }).join('') +
      '</div>' +
      '<p class="cadb-note">For design reference. Verify critical dimensions before production.</p>';
    card.setAttribute('aria-busy', 'false');
    loadVariants(p);
    renderBar(p, res);
  }
  function setTab(tab) {
    var p = sel; if (!p) return;
    var m = $('[data-cadb-cmedia]'); if (!m) return;
    m.innerHTML = cardMedia(p, tab);
    root.querySelectorAll('.cadb-tabs [data-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.tab === tab)); });
    if (tab === '3d') {
      var host = m.querySelector('[data-cadb-cmv]');
      var go = function () { var el = makeMV(false); el.setAttribute('src', p.g); el._p = p; host.appendChild(el); };
      if (customElements.get('model-viewer')) go(); else { loadMV(); customElements.whenDefined('model-viewer').then(go); }
    }
    track('cadb_card_tab', { tab: tab, sku: p.s });
  }
  function renderMore(res) {
    var host = $('[data-cadb-more]');
    var rest = res.list.filter(function (p) { return p !== sel; });
    if (!rest.length) { host.innerHTML = ''; return; }
    var lim = host._lim || 12;
    var title = res.exact ? rest.length + ' more match' + (rest.length === 1 ? '' : 'es') : 'Other close options';
    host.innerHTML = '<h3>' + title + '</h3><ul>' + rest.slice(0, lim).map(function (p) {
      var i = P.indexOf(p);
      return '<li><button type="button" data-pick="' + i + '"><img src="' + esc(imgw(p.img, 96)) + '" alt="" width="44" height="44" loading="lazy"><span><span class="pn">' + esc(p.s) + '</span><span class="ds">' + esc(shortDesc(p)) + '</span></span><span class="pr">' + money(p.pr) + '</span></button></li>';
    }).join('') + '</ul>' + (rest.length > lim ? '<button type="button" class="cadb-more-btn" data-more>Show ' + Math.min(24, rest.length - lim) + ' more</button>' : '');
  }
  function shortDesc(p) {
    return [(p.dl || fracLabel(p.d)) + (p.wl ? ' x ' + p.wl : ''), MAT[p.mt] || p.ml, p.c ? p.c.toLocaleString('en-US') + ' lb' : '', RIG[p.r][1] + (p.b !== 'N' ? ' + brake' : ''), MOUNT[p.m][1]].filter(Boolean).join(', ').replace(/"/g, ' in');
  }

  function genTitle(p) {
    if (p.t) return p.t;
    var d = (p.dl || fracLabel(p.d)).replace(/"/g, ' in'), w = (p.wl || '').replace(/"/g, ' in');
    var mat = (p.ml || MAT[p.mt] || '').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    var mt = p.m === 'P' ? 'Plate' : MOUNT[p.m][1].replace(' stem', ' Stem');
    return d + (w ? ' x ' + w : '') + ' ' + mat + ' ' + RIG[p.r][1] + (p.b === 'T' ? ' Total Lock' : p.b === 'W' ? ' Brake' : '') + ' ' + mt + ' Caster' + (p.set ? ' Set' : '') + (p.c ? ', ' + p.c.toLocaleString('en-US') + ' lb' : '');
  }

  /* ---------- variants + cart ---------- */
  var PH = /^\s*(must\s+)?choose\b/i;
  function optName(n) {
    var t = (String(n || 'option').toLowerCase().replace(/[:\s]+$/, '').replace(/^\s*(must\s+)?(choose|select|pick)\s+(your\s+|a\s+|an\s+)?/, '') || 'option').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    return t.replace(/(Size|Color|Colour|Option|Plate|Bearing|Brake|Wheel|Stem)s$/, '$1');
  }
  function curVariant() {
    var prod = sel && variantCache[sel.vid]; if (!prod) return null;
    var picks = Array.prototype.map.call(root.querySelectorAll('[data-cadb-opt]'), function (s) { return s.value; });
    if (picks.some(function (v) { return !v; })) return null;
    return prod.variants.filter(function (v) { return v.options.every(function (o, i) { return picks[i] === undefined || o === picks[i]; }); })[0] || null;
  }
  function updateType() {
    var p = sel, prod = p && variantCache[p.vid], dd = $('[data-cadb-type]'); if (!prod || !dd) return;
    var base = RIG[p.r][1] + ', ' + BRK[p.b][1].toLowerCase();
    var idx = -1;
    (prod.options || []).forEach(function (o, i) { if (idx < 0 && /brake|lock/i.test(o.name)) idx = i; });
    if (idx < 0) (prod.options || []).forEach(function (o, i) { if (idx < 0 && o.values.some(function (v) { return /brake|lock/i.test(v) && !PH.test(v); })) idx = i; });
    var s = idx >= 0 && root.querySelector('[data-cadb-opt="' + idx + '"]');
    var v = s && s.value;
    if (!v) { dd.textContent = base; return; }
    var lbl = /^\s*(no|none|without)\b/i.test(v) ? 'no brake' : v.replace(/\s+/g, ' ').trim().toLowerCase();
    if (!/brake|lock/i.test(lbl) && lbl !== 'no brake') { dd.textContent = base; return; }
    dd.textContent = RIG[p.r][1] + ', ' + lbl;
  }
  function refreshPrice() {
    updateType();
    var p = sel, prod = p && variantCache[p.vid], pe = $('[data-cadb-price]'); if (!prod || !pe) return;
    var v = curVariant();
    if (v) { pe.textContent = money(v.price / 100); return; }
    var real = prod.variants.filter(function (x) { return !x.options.some(function (o) { return PH.test(o); }); });
    var ps = (real.length ? real : prod.variants).map(function (x) { return x.price; });
    var lo = Math.min.apply(null, ps), hi = Math.max.apply(null, ps);
    pe.textContent = hi > lo ? 'From ' + money(lo / 100) : money(lo / 100);
  }
  function renderOpts(p, prod) {
    var host = $('[data-cadb-opts]'); if (!host) return;
    var opts = prod.options || [];
    if (prod.variants.length < 2 || !opts.length) { host.innerHTML = ''; refreshPrice(); return; }
    var def = prod.variants.filter(function (v) { return v.id === p.vid; })[0];
    var prev = Array.prototype.map.call(host.querySelectorAll('[data-cadb-opt]'), function (s) { return s.value; });
    var picks = opts.map(function (o, i) { var v = prev.length ? prev[i] : (def ? def.options[i] : ''); return v && !PH.test(v) ? v : ''; });
    host.innerHTML = opts.map(function (o, i) {
      var name = optName(o.name), vals = o.values.filter(function (v) { return !PH.test(v); });
      if (!vals.length) return '';
      var cur = curPrice();
      var html = vals.map(function (v) {
        /* price of the variant you would get with this value and the other current picks */
        var cand = prod.variants.filter(function (x) { return x.options[i] === v && x.options.every(function (ov, j) { return j === i || !picks[j] || ov === picks[j]; }) && !x.options.some(function (ov, j) { return j !== i && PH.test(ov) && picks[j]; }); });
        var pr = cand.length ? Math.min.apply(null, cand.map(function (x) { return x.price; })) : null;
        var av = cand.some(function (x) { return x.available; });
        var lbl = v.replace(/\s+/g, ' ').trim() + (pr != null && cur != null && pr !== cur ? ' (' + money(pr / 100) + ')' : '') + (cand.length && !av ? ' (sold out)' : '');
        return '<option value="' + esc(v) + '"' + (picks[i] === v ? ' selected' : '') + '>' + esc(lbl) + '</option>';
      }).join('');
      return '<label class="cadb-opt"><span>' + esc(name) + '</span><select data-cadb-opt="' + i + '"' + (vals.length === 1 ? '' : '') + '><option value="" disabled' + (picks[i] ? '' : ' selected') + ' hidden>Choose your ' + esc(name.toLowerCase()) + '</option>' + html + '</select></label>';
    }).join('');
    /* single-value options with only a placeholder alternative: preselect the one real value */
    host.querySelectorAll('[data-cadb-opt]').forEach(function (sl) { if (!sl.value && sl.options.length === 2) sl.value = sl.options[1].value; });
    refreshPrice();
    function curPrice() { var v = (function () { var ok = picks.every(function (x, j) { return x || !opts[j].values.some(function (y) { return !PH.test(y); }); }); if (!ok) return null; return prod.variants.filter(function (x) { return x.options.every(function (o, j) { return !picks[j] || o === picks[j]; }); })[0]; })(); return v ? v.price : null; }
  }
  function loadVariants(p) {
    var go = function (prod) { if (sel !== p || !prod || !prod.variants) return; renderOpts(p, prod); };
    if (variantCache[p.vid]) return go(variantCache[p.vid]);
    var getHandle = p.h ? Promise.resolve(p.h) : p._h ? Promise.resolve(p._h) : fetch('/variants/' + p.vid, { method: 'HEAD', credentials: 'same-origin' }).then(function (r) { var m = (r.url || '').match(/\/products\/([^/?#]+)/); return m ? (p._h = m[1]) : null; });
    getHandle.then(function (h) { return h ? fetch('/products/' + h + '.js', { credentials: 'same-origin' }) : null; })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (j) { if (j) { variantCache[p.vid] = j; go(j); } }).catch(function () {});
  }
  function addToCart(btn) {
    var p = sel; if (!p) return;
    var prod = variantCache[p.vid];
    var id = p.vid;
    if (prod && prod.variants.length > 1 && root.querySelector('[data-cadb-opt]')) {
      var v = curVariant();
      if (!v) {
        var miss = Array.prototype.filter.call(root.querySelectorAll('[data-cadb-opt]'), function (s) { return !s.value; })[0];
        var nm = miss ? miss.closest('.cadb-opt').querySelector('span').textContent.toLowerCase() : 'option';
        toast('Choose your ' + esc(nm) + ' first.'); if (miss) { miss.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); miss.focus({ preventScroll: true }); }
        return;
      }
      id = v.id;
    }
    var qi = $('[data-cadb-qty]'); var qty = Math.max(1, parseInt(qi ? qi.value : 1, 10) || 1);
    var btns = root.querySelectorAll('[data-cadb-cart],[data-cadb-bar-cart]');
    btns.forEach(function (b) { b.disabled = true; b.dataset.t = b.textContent; b.textContent = 'Adding...'; });
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () {
        track('add_to_cart', { currency: 'USD', value: p.pr * qty, items: [{ item_id: p.s, item_name: genTitle(p), price: p.pr, quantity: qty }], source: 'cad_builder' });
        toast('Added ' + qty + ' x ' + p.s + ' to your cart. <a href="/cart">View cart</a>');
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-bind="itemCount"],.cart-count,[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = false; el.classList.remove('hidden', 'is-hidden'); });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          root.dataset.cartCount = c.item_count;
        });
      })
      .catch(function (e) { toast(esc(e.message || 'Could not add to cart. Please try again.')); })
      .then(function () { btns.forEach(function (b) { b.disabled = false; b.textContent = b.dataset.t || 'Add to cart'; }); });
  }
  var toastT;
  function toast(html) {
    var t = $('[data-cadb-toast]'); t.innerHTML = html; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 6000);
  }

  /* ---------- mobile bar ---------- */
  function renderBar(p, res) {
    var bar = $('[data-cadb-bar]'); bar.hidden = false;
    var bv = $('[data-cadb-bar-view]'); if (bv) bv.href = purl(p);
    var n = res.exact ? res.list.length : 0;
    $('[data-cadb-bar-count]').textContent = !Object.keys(state).length ? 'See match' : res.exact ? (n === 1 ? '1 match' : n.toLocaleString('en-US') + ' matches') : 'Closest';
    var m = $('[data-cadb-dl-menu]');
    m.innerHTML = dlLinks(p).map(function (l) { return '<a href="' + esc(l.href) + '" ' + (l.k === 'drawing' ? 'target="_blank" rel="noopener nofollow"' : 'download rel="nofollow"') + ' data-dl="' + l.k + '">' + esc(l.t) + '</a>'; }).join('') + (chqLic(dlLinks(p)) ? '<p class="cadb-lic cadb-lic--menu">Free for design use. Redistribution or resale prohibited.</p>' : '');
  }

  /* ---------- 3D ---------- */
  var MV_SRC = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
  function loadMV() {
    if (mvLoading) return; mvLoading = true;
    if (window.customElements && customElements.get('model-viewer')) return;
    if (!document.querySelector('script[src="' + MV_SRC + '"]')) { var s = document.createElement('script'); s.type = 'module'; s.src = MV_SRC; document.head.appendChild(s); }
  }
  var IN = 0.0254;
  function frameMV(el) {
    /* auto-frame: centre on the bounding box and back off to fit its bounding sphere, with margin */
    try {
      var c = el.getBoundingBoxCenter(), d = el.getDimensions();
      var r = 0.5 * Math.sqrt(d.x * d.x + d.y * d.y + d.z * d.z);
      var fov = 30, host = el.getBoundingClientRect(), asp = host.height ? host.width / host.height : 1;
      var dist = r / Math.sin(fov * Math.PI / 360) * (asp < 1 ? 1.12 / asp : 1.12);
      el.cameraTarget = c.x.toFixed(4) + 'm ' + c.y.toFixed(4) + 'm ' + c.z.toFixed(4) + 'm';
      el.fieldOfView = fov + 'deg';
      el.minCameraOrbit = 'auto auto ' + (dist * 0.55).toFixed(4) + 'm';
      el.maxCameraOrbit = 'auto auto ' + (dist * 1.8).toFixed(4) + 'm';
      el.cameraOrbit = '35deg 72deg ' + dist.toFixed(4) + 'm';
      el.jumpCameraToGoal();
      el._box = { c: c, d: d };
    } catch (e) {}
  }
  function hotspots(el, p) {
    el.querySelectorAll('[slot^="hotspot-cadb"]').forEach(function (h) { h.remove(); });
    if (!p || !el._box) return;
    var c = el._box.c, d = el._box.d, y0 = c.y - d.y / 2, y1 = c.y + d.y / 2, x0 = c.x - d.x / 2, x1 = c.x + d.x / 2, z1 = c.z + d.z / 2;
    var wd = p.d ? Math.min(p.d * IN, d.y) : d.y * 0.5;
    var L = [];
    if (p.ms) L.push(['mount', (p.m === 'P' ? 'Plate ' : 'Stem ') + p.ms, [c.x, y1, c.z], '0 1 0']);
    if (p.dl || p.d) L.push(['wheel', 'Wheel ' + (p.dl || fracLabel(p.d)) + (p.wl ? ' x ' + p.wl : ''), [c.x, y0 + wd / 2, z1], '0 0 1']);
    if (p.ol) L.push(['oah', 'OAH ' + p.ol, [x1, c.y, c.z], '1 0 0']);
    if (p.sr && p.r === 'S') L.push(['sr', 'Swivel radius ' + p.sr, [x0, y0 + d.y * 0.7, c.z], '-1 0 0']);
    L.forEach(function (h, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cadb-hs'; b.slot = 'hotspot-cadb-' + h[0];
      b.dataset.position = h[2].map(function (v) { return v.toFixed(4) + 'm'; }).join(' ');
      b.dataset.normal = h[3]; b.dataset.visibilityAttribute = 'visible';
      b.textContent = h[1].replace(/"/g, ' in').replace(/\s+in\s+x\s+/g, ' x ');
      if (p.dr[0]) { b.dataset.zoom = p.dr[0]; b.setAttribute('aria-label', h[1] + '. Open the dimensioned drawing'); }
      el.appendChild(b);
    });
  }
  function makeMV(hero) {
    var el = document.createElement('model-viewer');
    ['camera-controls', 'disable-pan', 'ar'].forEach(function (a) { el.setAttribute(a, ''); });
    if (hero) el.setAttribute('disable-zoom', '');
    if (!reduce) { el.setAttribute('auto-rotate', ''); el.setAttribute('auto-rotate-delay', hero ? '0' : '2500'); el.setAttribute('rotation-per-second', '14deg'); }
    el.setAttribute('touch-action', 'pan-y'); el.setAttribute('interaction-prompt', 'none');
    el.setAttribute('shadow-intensity', '0.9'); el.setAttribute('shadow-softness', '0.8');
    el.setAttribute('exposure', '1'); el.setAttribute('tone-mapping', 'neutral'); el.setAttribute('environment-image', 'neutral');
    el.setAttribute('field-of-view', '30deg'); el.setAttribute('camera-orbit', '35deg 72deg auto');
    el.setAttribute('ar-modes', 'webxr scene-viewer quick-look'); el.setAttribute('loading', 'eager');
    wireMV(el);
    return el;
  }
  function wireMV(el) {
    if (el._wired) return; el._wired = 1;
    el.addEventListener('load', function () {
      frameMV(el); if (el._keepCam) { el.cameraOrbit = el._keepCam; el.jumpCameraToGoal && el.jumpCameraToGoal(); el._keepCam = null; } hotspots(el, el._p || sel);
      if (el === mvEl) { var po = $('[data-cadb-poster]'); if (po) po.classList.add('is-hidden'); root.dataset.mvLoaded = (+(root.dataset.mvLoaded || 0) + 1); if (!root.dataset.t3d && window.performance) root.dataset.t3d = Math.round(performance.now()); }
    });
    el.addEventListener('error', function () { root.dataset.mvError = '1'; });
    var first = true;
    el.addEventListener('camera-change', function (e) { if (first && e.detail && e.detail.source === 'user-interaction') { first = false; track('cad_view_3d', { sku: sel && sel.s }); } });
  }
  function initHeroMV() {
    var host = $('[data-cadb-mv-host]'); if (!host) return;
    mvEl = host.querySelector('model-viewer');
    if (mvEl) {
      mvEl._lite = mvEl.dataset.sku;
      var upgrade = function () {
        if (!mvEl._lite || !sel || sel.s !== mvEl._lite || !sel.g || !mvEl.loaded) return;
        mvEl._lite = null;
        try { var o = mvEl.getCameraOrbit(); mvEl._keepCam = o.theta + 'rad ' + o.phi + 'rad ' + o.radius + 'm'; } catch (e) {}
        mvEl.setAttribute('src', sel.g); root.dataset.heroUpgraded = '1';
      };
      ['pointerup', 'keydown'].forEach(function (ev) { mvEl.addEventListener(ev, upgrade); });
      root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-cadb-card] [data-tab], .cadb-hs')) upgrade(); });
      if (reduce) mvEl.removeAttribute('auto-rotate');
      wireMV(mvEl);
      if (mvEl.loaded) { frameMV(mvEl); var po = $('[data-cadb-poster]'); if (po) po.classList.add('is-hidden'); }
    }
    if (window.customElements) customElements.whenDefined('model-viewer').then(function () { mvReady = true; if (sel) showModel(sel); });
  }
  function showModel(p) {
    if (!p || bootHold) return;
    $('[data-cadb-stage-name]').textContent = p.s + ' | ' + shortDesc(p);
    var host = $('[data-cadb-mv-host]');
    var ph = $('[data-cadb-photo]');
    if (!p.g) {
      /* manufacturer-STEP product: no 3D viewer; show the drawing if there is one, else the photo, with a STEP badge */
      if (mvEl) mvEl.style.visibility = 'hidden';
      var po = $('[data-cadb-poster]'); if (po) po.classList.add('is-hidden');
      if (ph) { var u = p.dr[0] || p.img; ph.innerHTML = '<img src="' + esc(imgw(u, 900)) + '" alt="' + esc(genTitle(p)) + '"><span class="cadb-photo-badge">STEP download</span>'; ph.hidden = false; }
      $('[data-cadb-stage-cap]').textContent = 'Free STEP download for this part. 3D preview not available.';
      return;
    }
    if (ph) ph.hidden = true;
    if (mvEl) mvEl.style.visibility = '';
    $('[data-cadb-stage-cap]').textContent = 'Drag to rotate. Tap a label for the drawing.';
    if (!mvReady) { if (mvEl) mvEl._p = p; return; }
    if (!mvEl) { mvEl = makeMV(true); host.appendChild(mvEl); }
    mvEl._p = p;
    if (mvEl.dataset.sku === p.s) { if (mvEl.loaded) hotspots(mvEl, p); return; }
    mvEl.dataset.sku = p.s; mvEl._lite = null;
    mvEl.setAttribute('alt', '3D model of ' + p.s + ', ' + shortDesc(p) + '. Drag to rotate.');
    mvEl.setAttribute('src', p.g);
  }

  /* ---------- update ---------- */
  var lastRes;
  function update(opts) {
    opts = opts || {};
    if (state.size && state.mount == null) delete state.size;
    renderPickers();
    var res = compute();
    lastRes = res;
    if (!opts.keepSel || !sel || (res.list.indexOf(sel) < 0 && !sel._pinned)) { if (sel) sel._pinned = false; sel = res.list[0]; }
    renderCard(res);
    $('[data-cadb-more]')._lim = 12;
    renderMore(res);
    showModel(sel);
    writeURL();
    var live = $('[data-cadb-live]');
    live.textContent = res.exact ? res.list.length + ' casters match. Best match ' + sel.s + '.' : 'No exact match. Closest match ' + sel.s + '.';
    if (!opts.silent) track('cadb_match_view', { sku: sel.s, exact: res.exact });
  }

  /* ---------- search ---------- */
  var norm = function (s) { return String(s).toUpperCase().replace(/[^A-Z0-9]/g, ''); };
  function parseSpec(q) {
    var t = ' ' + q.toLowerCase().replace(/[”″]/g, '"').replace(/inch(es)?|in\b/g, '"') + ' ';
    var out = {}, hit = 0;
    var m = t.match(/(\d+(?:\.\d+)?(?:-\d+\/\d+)?)\s*"?\s*x\s*(\d+(?:\.\d+)?(?:-\d+\/\d+)?(?:\/\d+)?)\s*"?/);
    var toNum = function (s) { var a = s.match(/^(\d+)-(\d+)\/(\d+)$/); if (a) return +a[1] + a[2] / a[3]; a = s.match(/^(\d+)\/(\d+)$/); if (a) return a[1] / a[2]; return +s; };
    var nearest = function (fid, x) { var o = optsFor(FBY[fid]).map(function (o) { return +o[0]; }).filter(function (v) { return !isNaN(v); }); var b = null; o.forEach(function (v) { if (b == null || Math.abs(v - x) < Math.abs(b - x)) b = v; }); return b == null ? null : numKey(b); };
    if (m) { out.dia = nearest('dia', toNum(m[1])); out.w = nearest('w', toNum(m[2])); hit++; t = t.replace(m[0], ' '); }
    var c = t.match(/(\d[\d,]*)\s*(?:lb|lbs|#|pound)/);
    if (c) { var cv = +c[1].replace(/,/g, ''); var th = CAPS.filter(function (x) { return x <= cv; }).pop() || CAPS[0]; out.cap = String(th); hit++; t = t.replace(c[0], ' '); }
    if (!out.dia) { var d = t.match(/(?:^|\s)(\d+(?:\.\d+)?)\s*"/); if (d) { out.dia = nearest('dia', +d[1]); hit++; } }
    var words = [[/poly(?!olefin)|urethane|pu\b/, 'mat', 'poly'], [/nylon/, 'mat', 'nylon'], [/rubber/, 'mat', 'rubber'], [/tpr|elastomer/, 'mat', 'tpr'], [/phenolic/, 'mat', 'phenolic'], [/polyolefin|olefin/, 'mat', 'polyolefin'], [/iron|steel wheel|cast/, 'mat', 'iron'],
      [/plate/, 'mount', 'plate'], [/thread/, 'mount', 'threaded'], [/grip/, 'mount', 'grip'], [/expand/, 'mount', 'expanding'],
      [/swivel/, 'rig', 'swivel'], [/rigid|fixed/, 'rig', 'rigid'], [/total.?lock/, 'brake', 'total'], [/no brake/, 'brake', 'none'], [/brake|lock/, 'brake', 'wheel']];
    words.forEach(function (w) { if (out[w[1]] == null && w[0].test(t)) { out[w[1]] = w[2]; hit++; } });
    if (out.mount == null && /\bstem\b/.test(t)) { out.mount = 'threaded'; hit++; }
    return hit ? out : null;
  }
  function skuHits(q) {
    var n = norm(q); if (n.length < 3) return [];
    var a = [], b = [];
    P.forEach(function (p) { var s = p._n; if (s === n || s.indexOf(n) === 0) a.push(p); else if (s.indexOf(n) > 0) b.push(p); });
    return a.concat(b).slice(0, 8);
  }
  function pinProduct(p) {
    state = {};
    sel = p; p._pinned = true;
    renderPickers();
    var res = { exact: true, list: [p].concat(P.filter(function (x) { return x !== p && x.m === p.m && x.d === p.d && x.w === p.w && x.mt === p.mt; }).slice(0, 30)) };
    lastRes = res;
    renderCard(res); $('[data-cadb-more]')._lim = 12; renderMore(res); showModel(p); writeURL();
    $('[data-cadb-live]').textContent = 'Showing part ' + p.s + '.';
    track('cadb_match_view', { sku: p.s, exact: true, via: 'search' });
  }
  function runSearch(final) {
    var inp = $('#cadb-q'), q = inp.value.trim(), box = $('#cadb-sugg');
    if (final) clearTimeout(qT);
    if (!q) { box.hidden = true; inp.setAttribute('aria-expanded', 'false'); return; }
    var hits = skuHits(q);
    var exact = hits.filter(function (p) { return p._n === norm(q); })[0];
    if (final) {
      box.hidden = true; inp.setAttribute('aria-expanded', 'false');
      if (exact || (hits.length === 1)) { pinProduct(exact || hits[0]); scrollToCard(); return; }
      var spec = parseSpec(q);
      if (spec) { state = {}; for (var k in spec) if (spec[k] != null) state[k] = spec[k]; if (sel) sel._pinned = false; track('cadb_filter', { via: 'search', q: q }); update(); scrollToCard(); return; }
      if (hits.length) { pinProduct(hits[0]); scrollToCard(); return; }
      toast('No part number matches "' + esc(q) + '". Try a spec like 5x2 poly plate.');
      return;
    }
    if (!hits.length) { box.hidden = true; inp.setAttribute('aria-expanded', 'false'); return; }
    box.innerHTML = hits.map(function (p) { return '<button type="button" role="option" data-pick-s="' + P.indexOf(p) + '"><b>' + esc(p.s) + '</b><span>' + esc(shortDesc(p)) + '</span></button>'; }).join('');
    box.hidden = false; inp.setAttribute('aria-expanded', 'true');
  }
  function scrollToCard() {
    if (window.innerWidth < 990) { var c = $('.cadb-result'); if (c) c.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button,a'); if (!t || !root.contains(t)) return;
    if (t.dataset.f) {
      var f = t.dataset.f, v = t.dataset.v;
      if (state[f] === v) delete state[f]; else state[f] = v;
      if (f === 'mount') delete state.size;
      if (sel) sel._pinned = false;
      if (firstFilter) { firstFilter = false; track('cadb_start', {}); }
      track('cadb_filter', { facet: f, value: v });
      update();
      var nb = root.querySelector('[data-f="' + f + '"][data-v="' + CSS.escape(v) + '"]'); if (nb) nb.focus({ preventScroll: true });
      return;
    }
    if (t.dataset.clear) { delete state[t.dataset.clear]; if (t.dataset.clear === 'mount') delete state.size; update(); return; }
    if (t.hasAttribute('data-cadb-reset')) { state = {}; if (sel) sel._pinned = false; $('#cadb-q').value = ''; update(); return; }
    if (t.dataset.pick) { sel = P[+t.dataset.pick]; renderCard(lastRes); renderMore(lastRes); showModel(sel); sel._pinned = false; writeURL(); var c = $('[data-cadb-card]'); if (window.innerWidth < 990) c.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); track('cadb_match_view', { sku: sel.s, via: 'list' }); return; }
    if (t.dataset.pickS) { $('#cadb-q').value = P[+t.dataset.pickS].s; $('#cadb-sugg').hidden = true; pinProduct(P[+t.dataset.pickS]); scrollToCard(); return; }
    if (t.hasAttribute('data-more')) { var h = $('[data-cadb-more]'); h._lim = (h._lim || 12) + 24; renderMore(lastRes); return; }
    if (t.dataset.tab) { setTab(t.dataset.tab); return; }
    if (t.dataset.zoom) { var d = $('[data-cadb-zoom]'); $('[data-cadb-zoom-img]').src = imgw(t.dataset.zoom, 1600); $('[data-cadb-zoom-img]').alt = sel.s + ' dimensional drawing'; if (d.showModal) d.showModal(); else window.open(t.dataset.zoom, '_blank'); return; }
    if (t.dataset.qty) { var qi = $('[data-cadb-qty]'); qi.value = Math.max(1, (+qi.value || 1) + +t.dataset.qty); return; }
    if (t.hasAttribute('data-cadb-cart') || t.hasAttribute('data-cadb-bar-cart')) { addToCart(t); return; }
    if (t.hasAttribute('data-cadb-go')) { runSearch(true); return; }
    if (t.hasAttribute('data-cadb-dl-toggle')) { var m = $('[data-cadb-dl-menu]'); m.hidden = !m.hidden; t.setAttribute('aria-expanded', String(!m.hidden)); return; }
    if (t.hasAttribute('data-cadb-bar-count')) { $('.cadb-result').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); return; }
    if (t.dataset.dl) { track('cad_download', { format: t.dataset.dl, sku: sel && sel.s }); var mm = $('[data-cadb-dl-menu]'); mm.hidden = true; }
    if (t.hasAttribute('data-cadb-view')) track('select_item', { item_id: sel && sel.s, source: 'cad_builder' });
  });
  var qT;
  root.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-cadb-opt]') && sel && variantCache[sel.vid]) { renderOpts(sel, variantCache[sel.vid]); } });
  root.addEventListener('input', function (e) { if (e.target.id === 'cadb-q') { clearTimeout(qT); qT = setTimeout(function () { runSearch(false); }, 120); } });
  root.addEventListener('keydown', function (e) {
    if (e.target.id === 'cadb-q') {
      if (e.key === 'Enter') { e.preventDefault(); runSearch(true); }
      if (e.key === 'Escape') { $('#cadb-sugg').hidden = true; }
      if (e.key === 'ArrowDown') { var b = $('#cadb-sugg button'); if (b && !$('#cadb-sugg').hidden) { e.preventDefault(); b.focus(); } }
    } else if (e.target.closest && e.target.closest('#cadb-sugg')) {
      var bs = Array.prototype.slice.call(root.querySelectorAll('#cadb-sugg button')), i = bs.indexOf(e.target);
      if (e.key === 'ArrowDown' && bs[i + 1]) { e.preventDefault(); bs[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (bs[i - 1] || $('#cadb-q')).focus(); }
      if (e.key === 'Escape') { $('#cadb-sugg').hidden = true; $('#cadb-q').focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cadb-search')) { var s = $('#cadb-sugg'); if (s) s.hidden = true; }
    if (!e.target.closest('.cadb-bar-dl')) { var m = $('[data-cadb-dl-menu]'); if (m) m.hidden = true; }
  });

  /* ---------- boot ---------- */
  initHeroMV();
  var toRows = function (data) {
    var F = data.f, cdn = data.cdn;
    var abs = function (u) { return !u ? '' : /^https?:/.test(u) ? u : cdn + u; };
    return data.p.map(function (row) {
      var o = {}; F.forEach(function (k, i) { o[k] = row[i]; });
      o.img = abs(o.img); o.g = abs(o.g); o.st = abs(o.st); o.z = abs(o.z); o.os = abs(o.os); o.dr = (o.dr || []).map(abs);
      o._n = norm(o.s);
      return o;
    });
  };
  var setCount = function (n) { root.querySelectorAll('[data-cadb-count]').forEach(function (c) { c.textContent = n.toLocaleString('en-US'); }); };
  fetch(root.dataset.src).then(function (r) { return r.json(); }).then(function (data) {
    P = toRows(data);
    root.dataset.loaded = P.length;
    setCount(data.n || P.length);
    var pinned = readURL();
    var pp = pinned && P.filter(function (p) { return p._n === norm(pinned); })[0];
    if (pp && !Object.keys(state).length) { pinProduct(pp); }
    else {
      var def = root.dataset.default && P.filter(function (p) { return p.s === root.dataset.default; })[0];
      if (!Object.keys(state).length && def) bootHold = true;
      update({ silent: true });
      bootHold = false;
      if (!Object.keys(state).length && def) { sel = def; renderCard(lastRes); renderMore(lastRes); showModel(def); $('[data-cadb-live]').textContent = P.length + ' casters to choose from. Showing ' + def.s + '.'; }
      if (pp) { sel = pp; pp._pinned = true; renderCard(lastRes); renderMore(lastRes); showModel(pp); }
    }
    loadMV();
    /* manufacturer STEP catalog: loaded after the first render so the page stays fast */
    if (data.more) {
      var src2 = root.dataset.src.replace(/chq-cad-builder-v1\.json/, data.more);
      fetch(src2).then(function (r) { return r.json(); }).then(function (d2) {
        P = P.concat(toRows(d2));
        root.dataset.loaded = P.length; setCount(P.length);
        var pin2 = pinned && !pp && P.filter(function (p) { return p._n === norm(pinned); })[0];
        if (pin2 && !Object.keys(state).length) { pinProduct(pin2); return; }
        if (Object.keys(state).length) update({ silent: true, keepSel: true }); else { renderPickers(); renderMore(lastRes); }
      }).catch(function () {});
    }
  }).catch(function (e) {
    $('[data-cadb-groups]').innerHTML = '<p>Sorry, the CAD list did not load. Please refresh the page.</p>';
    root.dataset.error = String(e);
  });
})();
